import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { addNotification, removeNotification } from '../store/notificationsSlice'
import '../css/noification_component.css'

export const useNotification = () => {
  const dispatch = useDispatch()
  return useCallback((type, message, duration = 5000) => {
    const id = Date.now() + Math.random()
    dispatch(addNotification({ id, type, message }))
    setTimeout(() => dispatch(removeNotification(id)), duration)
  }, [dispatch])
}

export const NotificationContainer = () => {
  const notifications = useSelector(state => state.notifications)
  return (
    <div className="notification-container">
      {notifications.map(({ id, type, message }) => (
        <div key={id} className={`notification ${type}`}>{message}</div>
      ))}
    </div>
  )
}
